import React from 'react'
import { IMG_URL } from '../utils/Constants'
import { useDispatch } from 'react-redux'
import { addCardId, toggleshowDetails} from "../utils/detailsSlice";
const MovieCard = ({ posterPath , Movie_ID_fecth}) => {
const dispatch = useDispatch();
if(!posterPath) return null
const Posterclick = () =>{
    // console.log("clicked")
    // const MovieID = {Movie_ID_fecth} 
    // console.log(MovieID)
    dispatch(addCardId(Movie_ID_fecth))
    dispatch( toggleshowDetails(true))
}

    return (
    <div className='w-36 md:w-40 cursor-pointer'>
        <img alt ="Movie name" src={IMG_URL + posterPath} onClick={Posterclick}/>
    
    </div>
  )
}

export default MovieCard;